module.exports = __webpack_public_path__ + "img/bf.8c9b84ac.svg";